export default __webpack_public_path__ + "static/media/Sayali160.591e1157.jpg";